import { Branding, DisabledPrompt } from "@bcm-dev/bcms-vite";
import { TableColumnContainer, TableItemTextView, TableItemView, TableView } from "components/shared";
import { UICheckbox } from "components/ui";
import React from "react";
import EntitlementsTableAccordion, { EntitlementsTableItemContent } from "../EntitlementsTableAccordion";
import "./styles.css";

/**
 * @function EntitlementsTable
 * @return {React.Component}
 * @exported true
 * @description This is the entitlements main table view
 */
export default function EntitlementsTable(props) {
    return (
        <TableView className="entitlements-table">
            <TableColumnContainer className="entitlements-table-header">
                <TableItemTextView className="entitlement-col" text="Entitlement" />
                <TableItemTextView className="limit-col" text="Limit" />
                <TableItemView className="checkbox-col" >
                    <DisabledPrompt>
                        <UICheckbox label="" value="" dataPoint="Entitlement" />
                    </DisabledPrompt>
                </TableItemView>
            </TableColumnContainer>

            <EntitlementsTableAccordion header="Accounts" icon="RightDoubleChevronIcon" dataPoint="Accounts" />
            <Branding id="ach_abi22" value="true">
                <EntitlementsTableAccordion header="ACH" icon="RightDoubleChevronIcon" />
                <EntitlementsTableAccordion header="ACH Whitelist" icon="RightDoubleChevronIcon" />
            </Branding>
            
            <Branding id="rxp17_abi22" value="true">
                <EntitlementsTableAccordion header="Bill Pay" />
            </Branding>
            <Branding id="cards_abi22" value="true">
                <EntitlementsTableAccordion header="Cards" />
            </Branding>
            
            <EntitlementsTableAccordion header="Director Customization for eStatement and Check Images">
                <EntitlementsTableItemContent item="Electronic Document Enrollment" />
            </EntitlementsTableAccordion>
            <EntitlementsTableAccordion header="Entitlements">
                <EntitlementsTableItemContent item="Manage Business Billing" />
                <EntitlementsTableItemContent item="Manage Users" />
            </EntitlementsTableAccordion>
            <EntitlementsTableAccordion header="Spending" icon="RightDoubleChevronIcon" />
            <EntitlementsTableAccordion dataPoint="Transfers" header="Transfers" icon="RightDoubleChevronIcon" />
            <Branding id="wires_abi22" value="true">
                <EntitlementsTableAccordion header="Wires" icon="RightDoubleChevronIcon" />
            </Branding>
            <Branding id="zle_abi22" value="true">
                <EntitlementsTableAccordion header={ <>Zelle<span className="r-mark">&reg;</span></> } />
            </Branding>
        </TableView>
    );
}